import { Link } from 'react-router-dom';
import { COMICS } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20illustration%20of%20a%20magical%20library%20filled%20with%20floating%20Korean%20manhwa%20pages%20and%20glowing%20books%2C%20soft%20warm%20lighting%2C%20whimsical%20dreamy%20atmosphere%2C%20stylized%20fantasy%20art%2C%20pink%20and%20gold%20color%20palette%2C%20ethereal%20quality%2C%20clean%20composition%20with%20ample%20negative%20space%20for%20text%20overlay&width=1600&height=900&seq=hero-bg-kcomic&orientation=landscape"
          alt="韩国漫画网 - 韩漫在线阅读平台"
          title="韩国漫画网 韩漫在线阅读 免费韩国漫画"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40" />
      </div>

      <div className="relative z-10 w-full text-center px-4">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 tracking-tight">
          韩国漫画网
        </h1>
        <p className="text-base md:text-lg text-white/90 max-w-2xl mx-auto mb-6 leading-relaxed">
          韩漫在线阅读平台，提供免费的韩国漫画和无删减韩漫大全<br className="hidden sm:block" />
          资源持续更新，让您尽情浏览各类韩漫内容
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-book-open-line" />
            开始阅读
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 bg-background-50/20 text-white border border-white/30 px-6 py-3 rounded-md text-sm font-medium hover:bg-background-50/30 transition-colors whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-8">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">{COMICS.length}+</p>
            <p className="text-xs text-white/70">精选韩漫</p>
          </div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">10+</p>
            <p className="text-xs text-white/70">分类题材</p>
          </div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">每日</p>
            <p className="text-xs text-white/70">持续更新</p>
          </div>
        </div>
      </div>
    </section>
  );
}